/**
 * 工作空间布局（WorkspaceLayout / ConferenceWorkspaceLayout）下须配合
 * 固定可视高度 + Card body overflow 锁链的列表页路由白名单。
 *
 * 与 mainFixedTableScrollPaths 独立维护：
 * - 静态路径登记到 WORKSPACE_FIXED_TABLE_SCROLL_PATHS（精确匹配）
 * - 含动态段（如 :projectId / :conferenceId）的路径登记到 WORKSPACE_FIXED_TABLE_SCROLL_PATTERNS（正则匹配）
 *
 * 提示：动态段勿用长前缀粗匹配，需收敛到具体列表页路径，避免误命中详情/设置类子页。
 */
const WORKSPACE_FIXED_TABLE_SCROLL_PATHS = [];

const WORKSPACE_FIXED_TABLE_SCROLL_PATTERNS = [
    // 医评议工作空间 - 申报管理列表（/selection/projects/:pid/declarations）
    /^\/selection\/projects\/[^/]+\/declarations\/?$/,
    // 医评议工作空间 - 投票管理列表（/selection/projects/:pid/vote）
    /^\/selection\/projects\/[^/]+\/vote\/?$/,
    // 医评议工作空间 - 评议管理列表（/selection/projects/:pid/reviews）
    /^\/selection\/projects\/[^/]+\/reviews\/?$/,
    // 会议工作空间 - 机构管理列表（/conf/conferences/:id/organizations）
    /^\/conf\/conferences\/[^/]+\/organizations\/?$/,
    // 会议工作空间 - 直播管理列表（/conf/conferences/:id/lives）
    /^\/conf\/conferences\/[^/]+\/lives\/?$/,
    // 会议工作空间 - 嘉宾管理列表（/conf/conferences/:id/guests）
    /^\/conf\/conferences\/[^/]+\/guests\/?$/,
    // 会议工作空间 - 嘉宾行程列表（/conf/conferences/:id/guests/journeys）
    /^\/conf\/conferences\/[^/]+\/guests\/journeys\/?$/,
    // 劳务费管理（/conf/conferences/:id/laborfee）页顶筛选 + 双 Alert 占高，表格区走主容器自然滚动，不登记 fixed-scroll
];

const workspaceFixedTableScrollPathSet = new Set(WORKSPACE_FIXED_TABLE_SCROLL_PATHS);

/**
 * @param {string} pathname
 */
export function isWorkspaceFixedTableScrollPath(pathname) {
    if (workspaceFixedTableScrollPathSet.has(pathname)) return true;
    return WORKSPACE_FIXED_TABLE_SCROLL_PATTERNS.some(re => re.test(pathname));
}
